import React from 'react';
import { motion } from 'framer-motion';
export function UniqueMethod() {
  const letters = [{
    l: 'R',
    desc: 'Reconoce las señales de tu sistema nervioso'
  }, {
    l: 'E',
    desc: 'Entrena respuestas de calma en lugar de alerta'
  }, {
    l: 'S',
    desc: 'Somatiza: conecta cuerpo y mente conscientemente'
  }, {
    l: 'T',
    desc: 'Transforma hábitos desde la neuroplasticidad'
  }, {
    l: 'A',
    desc: 'Ancla nuevos patrones emocionales'
  }, {
    l: 'U',
    desc: 'Unifica tu energía mental, emocional y física'
  }, {
    l: 'R',
    desc: 'Restaura tu equilibrio interno sostenible'
  }, {
    l: 'A',
    desc: 'Activa tu vida desde la serenidad, no el miedo'
  }];
  return <section className="py-24 px-4 bg-sage/10 relative" data-id="element-277">
      <div className="max-w-4xl mx-auto" data-id="element-278">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-teal rounded-3xl md:rounded-[32px] p-5 sm:p-7 md:p-12 shadow-2xl relative overflow-hidden text-white" data-id="element-279">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl -mr-20 -mt-20" data-id="element-280"></div>

          <div className="text-center mb-10 relative z-10" data-id="element-281">
            <span className="bg-gold text-teal text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-widest mb-6 inline-block" data-id="element-282">
              EXCLUSIVO
            </span>
            <h2 className="font-heading font-bold text-2xl sm:text-3xl md:text-5xl mb-4 break-words" data-id="element-283">
              MÉTODO R.E.S.T.A.U.R.A™
            </h2>
          </div>

          <div className="space-y-4 relative z-10 max-w-2xl mx-auto" data-id="element-284">
            {letters.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className="flex items-center bg-white/10 rounded-xl p-4 backdrop-blur-sm border border-white/10" data-id="element-285">
                <span className="font-display font-bold text-3xl text-gold w-12 shrink-0" data-id="element-286">
                  {item.l}
                </span>
                <span className="font-sans text-beige text-sm md:text-base" data-id="element-287">
                  {item.desc}
                </span>
              </motion.div>)}
          </div>

          <div className="mt-10 text-center relative z-10" data-id="element-288">
            <div className="inline-block bg-white/20 backdrop-blur-md px-6 py-3 rounded-full border border-white/30 text-sm font-medium text-beige" data-id="element-289">
              Basado en neurociencia aplicada y regulación somática
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}